import classNames from "classnames";
import { Paragraph } from "../Typography";
import "./index.css";
import styles from "./ViewTab.module.scss";

function ViewTab({
    name,
    selected,
    onClick,
    id,
    children,
}: {
    id?: string;
    name: string;
    selected?: boolean;
    onClick: () => void;
    children?: React.ReactNode;
}) {
    const isNewPlanTab = id === "building-new-plan-tab";

    return (
        <div className={isNewPlanTab ? styles.newPlanWrapper : ""}>
            <Paragraph>
                <button
                    id={id}
                    type="button"
                    className={classNames("view-tab", selected && "selected")}
                    onClick={onClick}
                >
                    {children}
                    {name}
                </button>
            </Paragraph>
        </div>
    );
}

export default ViewTab;
